<template>
    <div class="about">
        <section class="toolbar">
            <div class="toolbar-container">
                <router-link id="back-button-about" v-bind:to="'/operator/home-page'"><img src="/static/images/back.png"></router-link>
                <h1>About</h1>
            </div>
        </section>
        <div class="about-app">

            <img src="../assets/vtrl-about-img.jpg">

            <p>This application is a proprietary product of the VVG group. For more information on how to use the app click the 'User Manual' Button.</p>

            <div class="user-manual-btn">
                <a id="download-manual" :href="this.$config.API+'/static/vtrl-manual.pdf'">User Manual</a>
                <a id="download-manual-spanish" :href="this.$config.API+'/static/vtrl-manual-spanish.pdf'">User Manual in Spanish</a>
            </div>

        </div>

        <section class="list-view">
            <div class="list-view-title">
                <h2 class="textleft">FAQ</h2>
            </div>
            <div class="list-container faq-list-container">
                <div class="accordian-container">
                    <div class="panel-group" id="accordion">
                        <div class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                    <a id="q1" class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseOne">
                                        <ul>
                                            <li>
                                                <div class="list-view-left">What is VTRL ELD App?</div>

                                            </li>
                                        </ul>
                                    </a>
                                </h4>
                            </div>
                            <div id="collapseOne" class="panel-collapse collapse">
                                <div class="panel-body">
                                    <div class="accordion-internal-container">
                                        <div class="accordion-internal-container-block">
                                            VTRL ELD Application Electric Log Book Application for Managing Operator’s Shift Timings and help Operator to be in compliance with HOS Rules.

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                    <a id="q2" class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo">
                                        <ul>
                                            <li>
                                                <div class="list-view-left">How can a Operator select an Asset?</div>

                                            </li>
                                        </ul>
                                    </a>
                                </h4>
                            </div>
                            <div id="collapseTwo" class="panel-collapse collapse">
                                <div class="panel-body">
                                    <div class="accordion-internal-container">
                                        <div class="accordion-internal-container-block">
                                            <div class="accordion-internal-container-block">
                                                In this case when the Operator Logs in, Next screen will show the list of Assets Mapped with the Operator, here Operator can select the Asset.

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                    <a id="q3" class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseThree">
                                        <ul>
                                            <li>
                                                <div class="list-view-left">What if any Asset is not mapped with Operator at any point of time?</div>

                                            </li>
                                        </ul>
                                    </a>
                                </h4>
                            </div>
                            <div id="collapseThree" class="panel-collapse collapse">
                                <div class="panel-body">
                                    <div class="accordion-internal-container">
                                        <div class="accordion-internal-container-block">
                                            <div class="accordion-internal-container-block">
                                                In this case when the Operator Logs in, Asset Selection page will show a message titled “No Assets Mapped, Please contact Administrator” with a Logout Button below the the Message.
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                    <a id="q4" class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseFour">
                                        <ul>
                                            <li>
                                                <div class="list-view-left">How can a Operator change his Duty Status?</div>

                                            </li>
                                        </ul>
                                    </a>
                                </h4>
                            </div>
                            <div id="collapseFour" class="panel-collapse collapse">
                                <div class="panel-body">
                                    <div class="accordion-internal-container">
                                        <div class="accordion-internal-container-block">
                                            <div class="accordion-internal-container-block">
                                                In Home Screen, Operator can see his Current Duty Status in the Upper Left corner below Title Bar. Clicking that block will navigate Operator to Change Duty Screen which will allow Operator to switch to different Duty Status and also allowing to add notes for switching to a particular status.
                                                <br/><br/> In case of Driving, Operator needs to click on “Start” Button in Home Screen which will navigate Operator to Log Timer screen.

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                    <a id="q5" class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseFive">
                                        <ul>
                                            <li>
                                                <div class="list-view-left">How can a Operator end his Shift?</div>

                                            </li>
                                        </ul>
                                    </a>
                                </h4>
                            </div>
                            <div id="collapseFive" class="panel-collapse collapse">
                                <div class="panel-body">
                                    <div class="accordion-internal-container">
                                        <div class="accordion-internal-container-block">
                                            <div class="accordion-internal-container-block">
                                                In Change Duty Status screen (accessible by clicking Current Duty status on Home Screen), Operator needs to click on “stop” button to stop his Shift for that day.

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                    <a id="q6" class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseSix">
                                        <ul>
                                            <li>
                                                <div class="list-view-left">How can a Operator send his logs in case of DOT Inspection?</div>

                                            </li>
                                        </ul>
                                    </a>
                                </h4>
                            </div>
                            <div id="collapseSix" class="panel-collapse collapse">
                                <div class="panel-body">
                                    <div class="accordion-internal-container">
                                        <div class="accordion-internal-container-block">
                                            <div class="accordion-internal-container-block">
                                                Operator can select Send Logs menu from Side bar which will preview logs of Past Seven days. Operator can enter DOT Inspector Email Address and mail logs.

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                    <a id="q7" class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseSeven">
                                        <ul>
                                            <li>
                                                <div class="list-view-left">How can a Operator Sign Logs?</div>

                                            </li>
                                        </ul>
                                    </a>
                                </h4>
                            </div>
                            <div id="collapseSeven" class="panel-collapse collapse">
                                <div class="panel-body">
                                    <div class="accordion-internal-container">
                                        <div class="accordion-internal-container-block">
                                            <div class="accordion-internal-container-block">
                                                Operator will need to Navigate to Sign Tab by clicking on any Past Seven Day Log, or Inspection Block on Home Screen. Here if Operator has not signed the Logs he will shown with Message and Button to Sign Log. If Operator has previously signed then it will show Sign there.

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                    <a id="q8" class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseEight">
                                        <ul>
                                            <li>
                                                <div class="list-view-left">What if I get stuck in the app or a loading screen?</div>

                                            </li>
                                        </ul>
                                    </a>
                                </h4>
                            </div>
                            <div id="collapseEight" class="panel-collapse collapse">
                                <div class="panel-body">
                                    <div class="accordion-internal-container">
                                        <div class="accordion-internal-container-block">
                                            <div class="accordion-internal-container-block">
                                                Simply pull down the screen to refresh the page. This issue might be caused by low internet connectivity.

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                    <a id="q8" class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseNine">
                                        <ul>
                                            <li>
                                                <div class="list-view-left">What if I want to edit my Logs?</div>

                                            </li>
                                        </ul>
                                    </a>
                                </h4>
                            </div>
                            <div id="collapseNine" class="panel-collapse collapse">
                                <div class="panel-body">
                                    <div class="accordion-internal-container">
                                        <div class="accordion-internal-container-block">
                                            <div class="accordion-internal-container-block">
                                                Operator can edit logs for the Past 7 Days + today. To edit log for a particular day Operator can select that day from the Home Screen. Inside Logs tabs there is button with a Edit Icon clicking on which will take the Operator to Edit Logs Screen. All the constraints have been listed in the Vtrl ELD manual which you can download by clicking on the User Manual Button above.
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end container -->
            </div>
        </section>

    </div>
</template>
<script>
export default {
    name: "about"
}
</script>




// WEBPACK FOOTER //
// src/components/about.vue